export default __webpack_public_path__ + "locales/fr/PortalUnavailable.json?hash=981708ae0cd2fd56179802aa166bf7d7";